import { RouterProvider } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { ApplicationLayout } from '@deere/fuel-react/ApplicationLayout.js';
import { oktaAuth, router } from './AppRouter';
import { LicenseInfo } from '@mui/x-license';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from './store';
import { getEnvVar } from './utils/getEnvVar';
import ApplicationThemeProvider from './shared/ApplicationThemeProvider';
import { ToastProvider } from './shared/ToastProvider';
import { LoginStateProvider } from './shared/LoginStateContext';
import SMFooter from './components/SMFooter';

// IMPORTANT: License Key Security
// For information on how to securely manage your Material-UI (MUI) license key,
// please refer to the MUI documentation: https://mui.com/x/introduction/licensing/#license-key-security

LicenseInfo.setLicenseKey(getEnvVar('VITE_MUI_LICENSE'));

const restoreOriginalUri = (_oktaAuth, originalUri) => {
  router.navigate(toRelativeUrl(originalUri || '/', window.location.origin), {
    replace: true
  });
};

export default function App() {
  return (
    <ReduxProvider store={store}>
      <ApplicationThemeProvider>
        <LoginStateProvider>
          <ToastProvider>
            <Security
              oktaAuth={oktaAuth}
              restoreOriginalUri={restoreOriginalUri}
            >
              <ApplicationLayout>
                <RouterProvider router={router} />
                <SMFooter />
              </ApplicationLayout>
            </Security>{' '}
          </ToastProvider>
        </LoginStateProvider>{' '}
      </ApplicationThemeProvider>
    </ReduxProvider>
  );
}
